import classNames from "classnames";
import React, { useEffect, useState } from "react";
import logo from "../img/logo.svg";

const langs = [
  { key: "ru", title: "Russian" },
  { key: "en", title: "English" },
  { key: "vt", title: "Vietnamese" },
];

const Navbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.addEventListener("click", hideMenu);
    return () => {
      document.removeEventListener("click", hideMenu);
    };
  }, []);
  const hideMenu = () => {
    setIsOpen(false);
  };
  const handleClickLangBtn = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="navbar">
      <div className="container">
        <a href="/" className="navbar__logo">
          <img src={logo} alt="TerraLeads blog" />
        </a>
        <div className={classNames("language-wrap", { "is-open": isOpen })}>
          <div
            className="language__btn"
            onClick={(e) => {
              e.stopPropagation();
              handleClickLangBtn();
            }}
          >
            <div className="language__top-line" />
            <span className="language__value">{props.lang}</span>
            <div className="language__bottom-line" />
          </div>
          <ul className="language__list">
            {langs.map((lang) => (
              <li
                key={lang.key}
                onClick={() => {
                  props.onLanguageSelect(lang.key);
                  setIsOpen(false);
                }}
              >
                <button className="terra-link-once">{lang.title}</button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
